import { Suspense, lazy, useContext } from 'react';
import { IAppToolsContext } from '../../../types/appTools';
import AppToolsContext from '../../../context/AppToolsContext';

const Collaboration = lazy(() => import('Collaboration'));

const CollaborationWrapper = ({ eventUniqueName }) => {
    const { sessionId } = useContext<IAppToolsContext>(AppToolsContext);
    return (
        <Suspense fallback={null}>
            <Collaboration eventUniqueName={eventUniqueName} sessionId={sessionId.toString()} />
        </Suspense>
    );
};

export default CollaborationWrapper;
